export type SelectUnityProps = {
	selectedUnity: string;
};

export const SET_SELECTED_UNITY = 'SET_SELECTED_UNITY';
